import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Layout, Spin } from "antd";
//Components
import { HisAcademico } from "../../../components/Admin/Aspirante";
// import { getHisAcademicoById } from "../../../redux/aspirante/reqAcademicoDuck";
import * as ducks from "../../../redux/aspirante/reqAcademicoDuck";
import * as func from "../../../utils";
import { getAllCatalogos } from "../../../redux/aspirante/catalogoDucks";
import { ModalAcademico } from "../../../components/Admin/Aspirante/ModalAcademico";
import { ERROR, TAB_REQ_ACADEMICO } from "../../../utils";
import { NuevoRegistro } from "../../Public/Aspirante/InfoAcademicaPage";
import { SinDatos } from "../../Public/Aspirante/InfoAcademicaPage";

export const ReqAcademicoPage = () => {
  const dispatch = useDispatch();
  const isMounted = useRef(true);
  const [form] = Form.useForm();
  //Hook para controlar el modal
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { loading, historial } = useSelector((state) => state.reqAcademico);
  const { isSaved, isError, mensaje } = useSelector(
    (state) => state.reqAcademico.statusForm
  );
  const { bloquearPorFecha } = useSelector((state) => state.bloqueoEstatus);
  const { estatusPostulacion } = useSelector(
    (state) => state.bloqueoEstatus.concurso
  );

  //Se cargan los catalogos
  useEffect(() => {
    dispatch(getAllCatalogos());
    //Se obtiene el historial académico
    dispatch(ducks.getHisAcademicoById());
    //Se limpia el req. académico si en dado caso esta activo
    dispatch(ducks.isActiveReqAcademico({}));
    return () => {
      isMounted.current = false; //Desmontar el componente
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    historial.length === 0 && dispatch(ducks.setExistenDatos(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [historial]);

  //useEffect que valida si hubo un error al registrar el aspirante o se guardó correctamente.
  useEffect(() => {
    isMounted.current && validaFormulario();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError, isSaved, mensaje]);

  const validaFormulario = () => {
    if (isSaved) {
      //Si todo se guardo correctamente
      func.nextTabConfirm(mensaje, TAB_REQ_ACADEMICO, "3", dispatch);
      form.resetFields();
      showModal();
    }
    if (isError) {
      func.openModalError(ERROR, mensaje); //Si hubo un error al momento de registrar
    }
    dispatch(ducks.setFormularioClean());
  };
  /**
   * Función para mostrar/ocultar el modal de registro
   */
  const showModal = () => {
    setIsModalVisible((state) => !state);
  };

  return (
    <Spin size="large" spinning={loading}>
      {/* Modal del formulario Req. Académico */}
      <ModalAcademico
        isModalVisible={isModalVisible}
        showModal={showModal}
        form={form}
      />
      <Layout className="site-layout">
        <div className="site-layout-content">
          <div>
            {/* Historial Académico */}
            {historial.length > 0 && (
              <div className="mt-20">
                <HisAcademico showModal={showModal} form={form} />
              </div>
            )}

            {historial.length === 0 && (
              <>
                <SinDatos />
                <div className="mt-50">
                  <NuevoRegistro
                    showModal={showModal}
                    isDisable={bloquearPorFecha || estatusPostulacion}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </Layout>
    </Spin>
  );
};
